import { useRecoilValue } from "recoil"
import { trulienceAtom } from "src/recoil/atoms/trulience"
import { avatarCommunication } from "../AvatarCommunication"

export const useAvatarMicManager = () => {
  const { micEnabled, micPermissionState } = useRecoilValue(trulienceAtom)

  const toggleMic = () => {
    avatarCommunication.toggleMic();
  }

  return {
    isEnabled: micEnabled,
    micPermissionState,
    toggleMic
  }
}

export const useAvatarSpeakerManager = () => {
  const { speakerEnabled } = useRecoilValue(trulienceAtom)

  const toggleSpeaker = () => {
    avatarCommunication.toggleSpeaker()
  }

  return {
    isEnabled: speakerEnabled,
    toggleSpeaker
  }
}
